import _ from 'common-tools/LodashHelper'
import { FieldValueParser } from './FieldValueConverters'

export const QueryFieldOperator = {
  EQUALS: 'EQUALS',
  NOTEQUALS: 'NOTEQUALS',
  LESSTHAN: 'LESSTHAN',
  LESSTHANEQUAL: 'LESSTHANEQUAL',
  GREATERTHAN: 'GREATERTHAN',
  GREATERTHANEQUAL: 'GREATERTHANEQUAL',
  IN: 'IN',
  NOTIN: 'NOTIN',
  CONTAINS: 'CONTAINS',
  STARTSWITH: 'STARTSWITH',
  ENDSWITH: 'ENDSWITH',
  MATCHES: 'MATCHES',
  NOTMATCHES: 'NOTMATCHES'
}

export const QueryFieldGroup = {
  AND: 'AND',
  OR: 'OR',
  MUST: 'MUST'
}

export const DataGridFilterValue = (name, value, operator, group, parameterName) => {
  return {
    Name: name,
    Value: value,
    Operator: operator || QueryFieldOperator.EQUALS,
    Group: group || QueryFieldGroup.AND,
    ParameterName: parameterName
  }
}

export const DataGridFilterValueSetup = (cfg = {}) => {
  return {
    fieldType: null,
    parse: function (value, name) {
      const setup = _.merge({
        ValueType: ''
      }, cfg)

      let inputName = name
      if (_.startsWith(inputName, 'Filters.')) {
        inputName = _.replace(inputName, 'Filters.', '')
      }

      if (_.isArray(value)) {
        return _.map(value, (v, i) => {
          return {
            Name: setup.Name || inputName,
            Operator: setup.Operator || QueryFieldOperator.EQUALS,
            Value: setup.ValueType === '' ? v : FieldValueParser(setup.ValueType)(v, name),
            Group: setup.Group || QueryFieldGroup.AND,
            ParameterName: setup.ParameterName || inputName
          }
        })
      } else {
        return {
          Name: setup.Name || inputName,
          Operator: setup.Operator || QueryFieldOperator.EQUALS,
          Value: setup.ValueType === '' ? value : FieldValueParser(setup.ValueType)(value, name),
          Group: setup.Group || QueryFieldGroup.AND,
          ParameterName: setup.ParameterName || inputName
        }
      }
    },
    format: function (value, name) {
      if (_.isArray(value)) {
        return _.map(value, (v, i) => v.Value)
      } else if (_.has(value, 'Value')) {
        return value.Value
      } else {
        return value
      }
    }
  }
}
